import _ from 'lodash';
import history from 'config/history';

import {parseGetParams} from 'utils/urls';

export type PaginationForStore = {
  offset: number;
  pageSize: number;
};

type PaginationForApi = {
  limit: number;
  offset: number;
};

export const transformPaginationForStoreToPaginationForApi = (
  storePagination: PaginationForStore
): PaginationForApi => {
  const {pageSize, offset} = storePagination;

  return {limit: pageSize, offset};
};

/*
Pulls the pagination from the URL GET parameters and casts it to PaginationForStore
*/
export const getPaginationFromUrl = (): PaginationForStore | {} => {
  const pageParams = parseGetParams(history.location.search);

  const urlPagination: {offset?: string; limit?: string} = _.pick(pageParams, [
    'offset',
    'limit'
  ]);

  if (!urlPagination.limit || !urlPagination.offset) {
    return {};
  }

  return {
    pageSize: parseInt(urlPagination.limit),
    offset: parseInt(urlPagination.offset)
  };
};

export type CursorPaginationForStore = {
  pageSize: number;
  cursor: number;
  hasPrevious: boolean;
  hasNext: boolean;
};

type CursorPaginationForApi = {
  limit: number;
  cursor: number;
};

/*
Pulls the pagination from the URL GET parameters and casts it to CursorPaginationForStore
*/
export const getCursorPaginationFromUrl = (): CursorPaginationForStore | {} => {
  const pageParams = parseGetParams(history.location.search);

  const urlPagination: {
    limit?: string;
    cursor?: string;
    hasPrevious?: string;
    hasNext?: string;
  } = _.pick(pageParams, ['limit', 'cursor', 'hasPrevious', 'hasNext']);

  if (!urlPagination.limit || !urlPagination.cursor) {
    return {};
  }

  return {
    pageSize: parseInt(urlPagination.limit),
    cursor: parseInt(urlPagination.cursor),
    hasPrevious:
      urlPagination.hasPrevious && JSON.parse(urlPagination.hasPrevious),
    hasNext: urlPagination.hasNext && JSON.parse(urlPagination.hasNext)
  };
};

export const transformCursorPaginationForStoreToPaginationForApi = (
  storePagination: CursorPaginationForStore
): CursorPaginationForApi => {
  const {pageSize, cursor} = storePagination;

  return {limit: pageSize, cursor};
};
